import JudasConstant from '@/src/pages/market/constants/JudasConstant';
import {
  CouponsRequest, MyCouponsExchangeRequest, OrderCouponsExchangeRequest, OrderCouponsRequest
} from './model';

export const TypeRequest = {
  MY_COUPONS: 0, // 未使用
  HISTORY_COUPONS_USED: 1, // 已使用
  HISTORY_COUPONS_EXPIRED: 2, // 已过期
  HISTORY_COUPONS_INVAILD: 5, // 已失效
};

export const URL = {
  COUPON_LIST_REQ_URL: 'v1/userinfo/my/coupon',
  ORDER_COUPON_LIST_REQ_URL: 'v1/order/getCouponList',
  MY_COUPONS_EXCHANGE: 'v1/userinfo/my/exchange',
  ORDER_COUPONS_EXCHANGE: 'v1/order/couponExchangeApply',
};

/**
 * 我的/历史-优惠券列表接口请求
 * @param orderRequest
 */
export async function couponListRequest(couponsRequest: CouponsRequest): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const url = URL.COUPON_LIST_REQ_URL;
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    params: null,
    data: {
      ...couponsRequest
    }
  };
    // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  indicatorModule.showLoading();
  return new Promise<any>((resolve, reject) => {
    networkModule.request(params, (result: any) => {
      indicatorModule.hideLoading();
      if (result.data) {
        if (result.data.code == 0 && result.data.data) {
          console.log('mycoupon request api success!');
          resolve(result.data.data);
        } else {
          console.log(`mycoupon request api error: ${result.data.message}`);
          reject(result.data.message);
        }
      } else {
        reject('error');
      }
    });
  });
}

/**
 * 提单-优惠券列表接口请求
 * @param orderRequest
 */
export async function orderCouponListRequest(orderCouponListRequest: OrderCouponsRequest): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const url = URL.ORDER_COUPON_LIST_REQ_URL;
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    params: null,
    data: {
      ...orderCouponListRequest
    }
  };
    // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  indicatorModule.showLoading();
  return new Promise<any>((resolve, reject) => {
    networkModule.requestWx(params, (result: any) => {
      indicatorModule.hideLoading();
      if (result.data) {
        if (result.data.code == 0 && result.data.data) {
          console.log('ordercoupon request api success!');
          resolve(result.data.data);
        } else {
          console.log(`ordercoupon request api error: ${result.data.message}`);
          reject(result.data.message);
        }
      } else {
        reject('error');
      }
    });
  });
}

/**
 * 我的券列表页-券兑换接口
 * @param orderRequest
 */
export async function myCouponExchange(exchangeCouponsRequest: MyCouponsExchangeRequest): Promise<any> {
  // @ts-ignore
  const WMStatistics = Mach.requireModule('Statistics');
  const networkModule = Mach.requireModule('Network');
  const url = URL.MY_COUPONS_EXCHANGE;
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    params: null,
    data: {
      ...exchangeCouponsRequest
    }
  };
    // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  indicatorModule.showLoading();
  return new Promise<any>((resolve, reject) => {
    networkModule.requestWx(params, (result: any) => {
      indicatorModule.hideLoading();
      if (result.data) {
        if (result.data.code == 0 && result.data.data) {
          console.log('myCouponExchange request api success!');
          resolve(result.data.data);
        } else {
          console.log(`myCouponExchange request api error: ${result.data.msg}`);
          // 失败状态埋点
          WMStatistics.view(JudasConstant.MY_COUPON_PROMO_CID, JudasConstant.COUPON_PROMO_FAIL_MV, { remind_reason: result.data?.code });
          // 回调信息
          reject(result.data.msg);
        }
      } else {
        // 非接口服务导致的异常上报-1
        WMStatistics.view(JudasConstant.MY_COUPON_PROMO_CID, JudasConstant.COUPON_PROMO_FAIL_MV, { remind_reason: -1 });
        reject('error');
      }
    });
  });
}

/**
 * 提单券列表页-券兑换接口
 * @param orderRequest
 */
export async function orderCouponExchange(exchangeCouponsRequest: OrderCouponsExchangeRequest): Promise<any> {
  // @ts-ignore
  const networkModule = Mach.requireModule('Network');
  const url = URL.ORDER_COUPONS_EXCHANGE;
  const params = {
    dataType: 'json',
    url,
    method: 'POST',
    params: null,
    data: {
      ...exchangeCouponsRequest
    }
  };
    // @ts-ignore
  const indicatorModule = Mach.requireModule('ActivityIndicator');
  indicatorModule.showLoading();
  return new Promise<any>((resolve, reject) => {
    networkModule.requestWx(params, (result: any) => {
      indicatorModule.hideLoading();
      if (result.data) {
        resolve(result.data);
      } else {
        reject('error');
      }
    });
  });
}
